import React, { Component } from 'react';
import firebase from './firebase.js';
import { Link } from 'react-router-dom';
import './Photo.css';

class Photo extends Component {
	constructor(props) {
    	super(props);
		this.checkbox = React.createRef();
	}

	componentDidMount() {
		const checkInput = this.checkbox.current;
		if (checkInput) {
			checkInput.checked = this.props.isFeatured ? true : false;
		}
	}

	deleteItem = (e) => {
		const itemsRef = firebase.database().ref('images/' + this.props.uid);
		const feedRef = firebase.database().ref('feed/');
		const featuredRef = firebase.database().ref('featured/');
		itemsRef.child(this.props.id).remove();
		feedRef.child(this.props.id).remove();
		featuredRef.child(this.props.id).remove();

		firebase.database().ref('users/' + this.props.uid).transaction(user => {
			user.imageCount--;
			return user;
		});
	}

	toggleFeatured = (e) => {
		const checked = e.target.checked;
		const isFeatured = {
			isFeatured: checked
		}
		const feedRef = firebase.database().ref('feed/');
		feedRef.child(this.props.id).update(isFeatured);
		const featuredRef = firebase.database().ref('featured/');
		if (checked) {
			const post = {
				uid: this.props.uid,
				name: this.props.name,
				id: this.props.id,
				url: this.props.url,
				time: this.props.alt,
				fullSizeUrl: this.props.fullSizeUrl,
			}
			featuredRef.child(this.props.id).update(post)
		} else {
			featuredRef.child(this.props.id).remove();
		}
	}

	render() {
		let photo;
		if (this.props.admin) {
			photo =
				<label htmlFor={this.props.id} className="image">
					<img alt={this.props.alt} src={this.props.url}/>
				</label>
		} else {
			photo =
				<a target="_blank" className="image" href={this.props.fullSizeUrl}>
					<img alt={this.props.alt} src={this.props.url}/>
				</a>
		}
		let checkbox;
		if (this.props.admin) {
			checkbox =
				<input
					id={this.props.id}
					onChange={this.toggleFeatured}
					type="checkbox"
					ref={this.checkbox}/>
		}
		let remove;
		if (this.props.delete) {
			remove = <a className="remove" onClick={(e) => { if (window.confirm("Are you sure you want to remove this item?")) this.deleteItem(e) } }>Remove</a>
		}
		let profileLink;
		if (this.props.name && this.props.uid && !this.props.isProfile) {
			profileLink = <Link className="author" to={`/u/${this.props.uid}`}>{this.props.name}</Link>
		}
		return (
			<li className={"photo " + (this.props.isFeatured && this.props.admin ? 'featured' : '')}>
				{photo}
				<div className="photo-footer">
					{checkbox}
					{remove}
					{profileLink}
				</div>
			</li>
		);
	}
}

export default Photo;


// WEBPACK FOOTER //
// ./src/Photo.js